// The one new-subscription offer. The public website and the app's paywall
// and Billing page all read it, so their price, trial and allowance agree.
// The backend's STRIPE_PRICE_ID_PRO selects the price actually charged, and
// the native apps show the store's localized offer. `dailyStops` mirrors the
// Pro plan's daily allowance; change it here if the backend's limit changes.
export const V2_WEB_OFFER = Object.freeze({ price: '$20', currency: 'USD', trialDays: 7, dailyStops: 100 });
